export default __webpack_public_path__ + "static/media/placement.62492c64.svg";